import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginForm } from "@marekl/adminer/components";
import type { User } from "../../auth/queries";
import { getSafeReturnTo } from "../../auth/returnTo";
import { FaktioBrand } from "../../shell/FaktioBrand";

export function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = getSafeReturnTo(searchParams.get("returnTo"));

  return (
    <LoginForm<User>
      brand={<FaktioBrand />}
      subtitle="Přihlaste se do fakturace"
      onSuccess={() => navigate(returnTo, { replace: true })}
    />
  );
}
